// ============================================================================
// PrefixRedirect — preserves the trailing path, query string and hash when an
// old top-level route moves under a hub. Used for the Option D nav migration
// so every legacy deep link (/subcontractors/SUB-1, /contracts/new?x=1, …)
// lands on its new home with params intact.
//
//   <Route path="/subcontractors/*"
//          element={<PrefixRedirect from="/subcontractors" to="/people/subcontractors" />} />
// ============================================================================

import { Navigate, useLocation } from 'react-router-dom';

export function PrefixRedirect({ from, to }: { from: string; to: string }) {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.startsWith(from) ? pathname.slice(from.length) : '';
  return <Navigate to={`${to}${rest}${search}${hash}`} replace />;
}
